type AccessTokenAccessor = () => string | null;

// The admin shell and embedded applications can be emitted as separate Vite
// chunks (and, in development, can even resolve separate copies of this
// package). A module-local variable is therefore not a reliable bridge. A
// global symbol gives every copy the same in-memory slot without exposing a
// string-named property on window.
const accessTokenAccessorKey = Symbol.for('@nwm-oss/auth-react/access-token-accessor');

type AccessTokenGlobal = typeof globalThis & {
  [accessTokenAccessorKey]?: AccessTokenAccessor;
};

function accessTokenGlobal(): AccessTokenGlobal {
  return globalThis as AccessTokenGlobal;
}

export function registerFrontendAccessTokenAccessor(fn: () => string | null): void {
  accessTokenGlobal()[accessTokenAccessorKey] = fn;
}

export function getCurrentFrontendAccessToken(): string | null {
  return accessTokenGlobal()[accessTokenAccessorKey]?.() ?? null;
}
